import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCommentComponent } from "./med-icon-comment.component";

@NgModule({
  declarations: [
    MedIconCommentComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCommentComponent,
  ],
})
export class MedIconCommentModule { }
